import { useTranslation } from 'react-i18next'
import { FieldArray, useField } from 'formik'
import { TermsAndConditions } from '@dhl/receiver-dhl-extra-api'
import { Body1, Card, Grid, H6 } from '@dhl-ui/components'
import { CheckboxInput, TextFieldInput } from '@dhl/formik'

const defaultTermsAndConditions: TermsAndConditions = {
  mustAcknowledge: false,
  links: [
    {
      language: 'en',
      link: '',
    },
    {
      language: 'nl',
      link: '',
    },
  ],
}

type Props = {
  name: string
}

export const TermsAndConditionsInput = ({ name }: Props) => {
  const { t } = useTranslation()
  const [{ value: termsAndConditions }, { initialValue: initialTermsAndConditions }, { setValue }] = useField<
    TermsAndConditions | undefined
  >(name)

  const handleChange = () => {
    if (termsAndConditions) {
      setValue(undefined)
    } else {
      setValue(initialTermsAndConditions ?? defaultTermsAndConditions)
    }
  }

  return (
    <>
      <Grid>
        <H6>{t('admin.dhlExtraPage.promotionsPage.promotionForm.termsAndConditions.title')}</H6>
      </Grid>
      <Grid>
        <CheckboxInput
          name={name}
          onChange={handleChange}
          checked={Boolean(termsAndConditions)}
          label={t('admin.dhlExtraPage.promotionsPage.promotionForm.termsAndConditions.config')}
        />
      </Grid>
      {termsAndConditions && (
        <Grid>
          <Card>
            <Card.Content>
              <Grid container spacing={2}>
                <Grid>
                  <Body1>{t('admin.dhlExtraPage.promotionsPage.promotionForm.termsAndConditions.description')}</Body1>
                </Grid>
                <FieldArray
                  name={`${name}.links`}
                  render={() =>
                    termsAndConditions?.links?.map((link, index) => {
                      const { language } = link
                      return (
                        <Grid size={{ xs: 6 }} key={`link-${index}`}>
                          <TextFieldInput
                            fullWidth
                            label={t('admin.dhlExtraPage.promotionsPage.promotionForm.termsAndConditions.linkFor', {
                              lang: language.toUpperCase(),
                            })}
                            name={`${name}.links.${index}.link`}
                            type="text"
                          />
                        </Grid>
                      )
                    })
                  }
                />
                <Grid>
                  <CheckboxInput
                    name={`${name}.mustAcknowledge`}
                    label={t('admin.dhlExtraPage.promotionsPage.promotionForm.termsAndConditions.mustAcknowledge')}
                  />
                </Grid>
              </Grid>
            </Card.Content>
          </Card>
        </Grid>
      )}
    </>
  )
}
